import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env?.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env?.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('❌ CRITICAL: Supabase environment variables are missing!');
  console.error('VITE_SUPABASE_URL:', supabaseUrl ? '✓ Set' : '✗ Missing');
  console.error('VITE_SUPABASE_ANON_KEY:', supabaseAnonKey ? '✓ Set' : '✗ Missing');
  throw new Error('Supabase configuration is incomplete. Please check your .env file.');
}

console.log('✓ Supabase client initializing...');
console.log('  URL:', supabaseUrl);
console.log('  Environment:', import.meta.env?.MODE);

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storage: window?.localStorage,
    storageKey: 'zentri-auth-token'
  },
  global: {
    headers: {
      'x-client-info': `zentridms-web/${import.meta.env?.MODE}`
    }
  },
  realtime: {
    params: {
      eventsPerSecond: 10
    }
  }
});

// Add connection monitoring
supabase?.auth?.onAuthStateChange((event, session) => {
  console.log('[SUPABASE_AUTH] Auth state changed:', event);
  if (event === 'SIGNED_IN') {
    console.log('[SUPABASE_AUTH] User signed in:', session?.user?.email);
  } else if (event === 'SIGNED_OUT') {
    console.log('[SUPABASE_AUTH] User signed out');
  } else if (event === 'TOKEN_REFRESHED') {
    console.log('[SUPABASE_AUTH] Token refreshed');
  }
});

console.log('✓ Supabase client initialized successfully');